/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { getTimeSince } from '@squiz/dxp-console-support';
import { format } from 'date-fns';
import React from 'react';
import { ICON_NEW_RELEASES } from '../../Icons';
import { DataList, DataListItem } from '../DataList';
import { ActivityLogEvent } from './ActivityLog.defs';
import { ActivityLogProps, activityLogDefaults } from './ActivityLog.props';

/**
 * SDS ActivityLog component.
 */
export const ActivityLog = (props: ActivityLogProps): JSX.Element => {
  const { classes, emptyMessage, iconMap, key, limit, logs, timestampDescription, title, ...rest } = {
    ...activityLogDefaults,
    ...props,
  };

  const getActivityItems = (): Array<DataListItem> => {
    return logs.map((log: ActivityLogEvent, index): DataListItem => {
      const itemKey = `key-${index}-${log.message}`;
      const itemRelativeDate = getTimeSince(log.createdAt);
      const logContent = {
        __html: log.message,
      };

      const content = (
        <div className="sds-activity-log__message">
          <span dangerouslySetInnerHTML={logContent} />
        </div>
      );
      const footer = (
        <div className="sds-activity-log__timestamp">
          {itemRelativeDate && <span>{`${itemRelativeDate.amount} ${itemRelativeDate.unit}`}</span>}
        </div>
      );
      const icon = iconMap[log.type] || ICON_NEW_RELEASES;
      return { content, footer, icon, key: itemKey } as DataListItem;
    });
  };

  // DataList configurations
  const dataTimestamp = format(new Date(), 'h:mm aaa');
  const lastUpdated = (
    <div className="sds-activity-log__header">
      <em className="sds-activity-log__timestamp">
        {timestampDescription} {dataTimestamp}
      </em>
    </div>
  );

  return (
    <DataList
      {...rest}
      classes={classes}
      empty={emptyMessage}
      headerContent={lastUpdated}
      isInteractive={false}
      items={getActivityItems()}
      limit={limit}
      title={title}
    />
  );
};
